<span id="mitsCheckButtonWrapper">
  <span class="mitsCheckButton disable-text-select" [ngClass]="{'active': state, 'inactive': disable}"
    (click)="clickButton($event)">
    <mits-icon name="check"></mits-icon>
  </span>
</span>